export default {
  failed_to_open: 'Tämän ravintolan käyttöönottoa ei voitu avata. Yritä uudelleen.',
};
